export default __webpack_public_path__ + "scene4_3_icona49951.png";